/**
 * Display names for user roles. The stored values never change — `viewer` is
 * shown as "View All" — so anything a person reads goes through roleLabel.
 */
export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  clinic_admin: 'Clinic Admin',
  physician_manager: 'Physician Manager',
  pharmacy_manager: 'Pharmacy Manager',
  program_manager: 'Program Manager',
  data_entry: 'Data Entry',
  viewer: 'View All',
  report_viewer: 'Report Viewer',
  tv_display: 'TV Display',
}

export function roleLabel(role) {
  if (!role) return ''
  return ROLE_LABELS[role] || String(role).replace(/_/g, ' ')
}
